<template>
  <div class="wallet">
    <div class="summary">
      <div>
        <h3>{{ month | month }} {{ year }}</h3>
        <Summary v-if="wallet"></Summary>
      </div>
      <div class="action">
        <div class="btn-group" role="group">
          <button type="button" class="btn btn-dark" v-on:click="saveWallet">
            <font-awesome-icon icon="save" />
          </button>
          <button type="button" class="btn btn-dark" v-on:click="removeWallet">
            <font-awesome-icon icon="trash-alt" />
          </button>
          <button type="button" class="btn btn-dark" v-on:click="refreshWallet">
            <font-awesome-icon icon="sync-alt" />
          </button>
        </div>
      </div>
    </div>

    <b-tabs class="wallet-items" content-class="mt-3" justified>
      <b-tab active>
        <template v-slot:title>
          <span>Expenses</span>
          <button type="button" class="btn btn-dark" v-on:click="addExpense">
            <font-awesome-icon icon="plus" />
          </button>
        </template>

        <Expenses
          ref="expenses" v-if="wallet && wallet.data"
          v-bind:expenses="wallet.data.expenses"
          v-bind:editable="true" @refresh="refreshExpenses"
        ></Expenses>
      </b-tab>
      <b-tab>
        <template v-slot:title>
          <span>Salaries</span>
          <button type="button" class="btn btn-dark" v-on:click="addSalary">
            <font-awesome-icon icon="plus" />
          </button>
        </template>

        <Salaries
          ref="salaries" v-if="wallet && wallet.data"
          v-bind:salaries="wallet.data.salaries" @refresh="refreshSalaries"
        ></Salaries>
      </b-tab>
    </b-tabs>

    <ModalQuestion ref="question"></ModalQuestion>
    <Spinner v-if="spinner"></Spinner>
  </div>
</template>

<script>
export default {
  props: ["year", "month"],
  methods: {
    refreshExpenses(expenses) {
      this.wallet.data.expenses = [...expenses];
      this.$forceUpdate();
    },
    refreshSalaries(salaries) {
      this.wallet.data.salaries = [...salaries];
      this.$forceUpdate();
    },
    addSalary() {
      this.$refs.salaries.addSalary();
    },
    addExpense() {
      this.$refs.expenses.addExpense();
    },
    saveWallet() {
      this.wallet.save();
    },
    removeWallet() {
      this.$refs.question
        .ask("Czy usunąć")
        .then(() => {
          this.wallet.remove().then(() => {
            this.$router.push("/wallets");
          });
        })
        .catch(() => {});
    },
    refreshWallet() {
      this.wallet.reset();
    }
  },
  data() {
    return {
      spinner: false
    };
  },
  asyncComputed: {
    wallet() {
      this.spinner = true;
      return this.$piggyBank.data
        .getWallet(this.year, this.month)
        .then(wallet => {
          this.$store.commit('wallet', wallet);
          return wallet;
        })
        .catch(() => {
          this.$router.push("/wallets");
        })
        .finally(() => {
          this.spinner = false;
        });
    }
  }
};
</script>

<style lang="scss">
.wallet {
  flex: 1;
  height: 100%;
  margin: 0px;
  display: flex;
  flex-direction: column;
  position: relative;

  .summary {
    display: flex;

    & > *:not(.action) {
      flex: 1;
    }
  }

  .wallet-items {
    flex: 1;
    overflow: hidden;

    .nav.nav-tabs {
      

      .nav-item {
      
      
        .nav-link {
          height: 50px;
          display: flex;
          justify-content: center;
          align-items: center;

          button {
            margin-left: 10px;
          }

          // &.active {

          // }
        }
      }
    }

    .tab-content {
      height: calc(100% - 42px - 1rem);

      .tab-pane {
        height: 100%;
        overflow-y: auto;

        // .actions {
        //   opacity: 0.3;
        //   transform: scale(0.8);
        //   transition: all 0.25s;

        //   &:hover {
        //     opacity: 1;
        //     transform: scale(1);
        //   }
        // }

        .salary-item {
          border-top: 1px solid gray;
        }
      }
    }
  }

  a:not(.active) button {
    display: none;
  }

  // .mobile & {
  //   margin-top: 50px;
  // }
}
</style>